<template>
    <el-input :size="size" :type="type" v-model.trim="inputValue" 
        :clearable="clearable" :placeholder="placeholder" :rows="rows" :show-password='password' :minlength="minlength" :suffix-icon="suffixicon" :prefix-icon="prefixicon"
        :disabled="disabled" :readonly="readonly" @focus="onFocus" @blur="onBlur" @input="onInput" @change="onChange" :maxlength="maxlength" :autofocus="autofocus">
        <!-- 前置 -->
        <template slot="append">
            <slot name="append"></slot>
        </template>
        <!-- 后置 -->
        <template slot="prepend">
            <slot name="prepend"></slot>
        </template>
    </el-input>
</template>

<script>
    export default {
        props: {
            type: {
                type: String,
                default: 'text'
            },
            size: {
                type: String,
                default: ''
            },
            value: [String, Number],
            placeholder: {
                type: String,
                defalut: '请输入内容'
            },
            clearable: {
                type: Boolean,
                default: false
            },
            disabled: {
                type: Boolean,
                default: false
            },
            readonly: {
                type: Boolean,
                default: false
            },
            autofocus: {
                type: Boolean,
                default: false
            },
            rows: {
                type: Number,
                default: 2
            },
            password: {
                type: Boolean,
                default: false
            },
            maxlength: [Number],
            minlength: [Number],
            suffixicon: {
                type: String,
                default: ''
            },
            prefixicon: {
                type: String,
                default: ''
            }
        },
        watch: {
            value: {
				handler: function(val) {
					this.inputValue = val
				},
				immediate: true
			}
        },
        data() {
            return {
                inputValue: this.value,
            }
        },
        methods: {
            onInput(val) {
                let value = val
				this.inputValue = val
                this.$emit('input', value)
            },
            onFocus() {
                let value = this.inputValue
                this.$emit('focus',value)
            },
            onBlur() {
                let value = this.inputValue
                this.$emit('blur',value)
            },
            onChange(val) {
                this.$emit('change',val)
            }
        }
    }
</script>

<style scoped>
    .el-form-item__content .el-input-group {
        vertical-align: inherit;
    }
</style>